import React from 'react';
import {
  Container,
  CalendarHeader,
  CalendarTitle,
  CalendarNavButton,
  CalendarGrid,
  CalendarDayHeader,
} from './CalendarSection.styled';
import { CalendarDay } from './components/CalendarDay';
import { 
  ArrowLeftIcon,
  ArrowRightIcon
} from '../../../../components/Icons';

interface CalendarDayData {
  date: Date;
  isToday: boolean;
  isSelected: boolean;
  status?: 'present' | 'absent' | 'late' | 'early_leave';
}

interface CalendarSectionProps {
  weekDays: CalendarDayData[];
  onPrevWeek: () => void;
  onNextWeek: () => void;
  onDayClick: (date: Date) => void;
}

const CalendarSectionComponent: React.FC<CalendarSectionProps> = ({
  weekDays,
  onPrevWeek,
  onNextWeek,
  onDayClick,
}) => {
  const dayHeaders = ['日', '月', '火', '水', '木', '金', '土'];
  const title = weekDays[0]
    ? `週間カレンダー(${weekDays[0].date.getFullYear()}年${weekDays[0].date.getMonth() + 1}月)`
    : 'カレンダー';
  const lastDay = weekDays[weekDays.length - 1];

  return (
    <Container role="region" aria-label="週カレンダー">
      <CalendarHeader>
        <CalendarNavButton
          onClick={onPrevWeek}
          aria-label="前の週"
        >
          <ArrowLeftIcon />
        </CalendarNavButton>
        <CalendarTitle id="calendar-title">{title}</CalendarTitle>
        <CalendarNavButton
          onClick={onNextWeek}
          aria-label="次の週"
          disabled={lastDay && lastDay.date >= new Date()}
        >
          <ArrowRightIcon />
        </CalendarNavButton>
      </CalendarHeader>
      <CalendarGrid role="grid" aria-labelledby="calendar-title">
        {dayHeaders.map((day, index) => (
          <CalendarDayHeader key={day} $dayIndex={index} role="columnheader">
            {day}
          </CalendarDayHeader>
        ))}
        {weekDays.map((day, index) => (
          <CalendarDay
            key={index}
            index={index}
            date={day.date}
            isToday={day.isToday}
            isSelected={day.isSelected}
            status={day.status}
            onClick={() => onDayClick(day.date)}
          />
        ))}
      </CalendarGrid>
    </Container>
  );
};

// React.memoで最適化: propsが変わらない限り再レンダリングしない
export const CalendarSection = React.memo(CalendarSectionComponent);

export default CalendarSection;
